import { Component } from 'react';
import { connect } from 'react-redux';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { List } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/transitional/components/View';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { TEST_MODAL_TYPES, NO_TEST_ACCESS, SMART_CONTENT } from 'ContentEditorUI/lib/modalConstants';
import { getMABCreatableMap, getIsAnyTestRunning
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import { getActiveStagingDomain } from 'ContentEditorUI/redux/selectors/portalDomainsSelectors';
import { getPortalHasABTesting } from 'ContentEditorUI/redux/selectors/portalSelectors';
import { getPortalScopesRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
import { requestUninitialized, requestStarted, requestSucceeded } from 'redux-request-state/util/requestStateCheckers';
import { getIsPersonalized, getContentModelPersonalizationStrategyId } from '../redux/selectors/pageContentModelSelectors';
import { RunATestOption, RunATestDisabledTooltip } from '../components/RunATestOption';
import { getManagePersonalizationVariantsUrl } from '../utils/PersonalizationVariantsUtils';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AbTestPql = () => {
  const {
    openUpgradeModal: openABTestUpgradeModal
  } = useUpgradeModal('landing-pages-ab-testing-editor');
  return /*#__PURE__*/_jsx(RunATestOption, {
    dataTestId: "run-a-test__ab--pql",
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "consolidatedRunTestEntryPoints.ab.description"
    }),
    isOptionDisabled: false,
    onClick: openABTestUpgradeModal,
    title: /*#__PURE__*/_jsxs(TFlex, {
      direction: "row",
      justify: "between",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "mab.buttons.ab.header"
      }), /*#__PURE__*/_jsx(LockBadge, {
        size: "200"
      })]
    })
  });
};
const mapStateToProps = state => ({
  isStagedContent: Boolean(getActiveStagingDomain(state)),
  portalHasABTesting: getPortalHasABTesting(state),
  portalScopesRequest: getPortalScopesRequest(state),
  mabCreatableMap: getMABCreatableMap(state),
  isAnyTestRunning: getIsAnyTestRunning(state),
  isPersonalized: getIsPersonalized(state),
  personalizationStrategyId: getContentModelPersonalizationStrategyId(state)
});
class PatagoniaRunATestWrapper extends Component {
  renderInfoToolTip() {
    const {
      isAnyTestRunning
    } = this.props;
    if (!isAnyTestRunning) {
      return null;
    }
    return /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'mab.buttons.mab.disabledTooltip.hasTestRunning'
      }),
      placement: "right",
      children: /*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(InfoIcon, {})
      })
    });
  }
  renderRunAbTestOption() {
    const {
      portalScopesRequest,
      portalHasABTesting,
      openRunTestModal,
      isAnyTestRunning,
      isPersonalized,
      personalizationStrategyId
    } = this.props;
    const showPql = requestSucceeded(portalScopesRequest) && !portalHasABTesting;
    if (showPql) {
      return /*#__PURE__*/_jsx(AbTestPql, {});
    }
    const isOptionDisabled = isAnyTestRunning || isPersonalized;
    return /*#__PURE__*/_jsx(RunATestOption, {
      dataTestId: "run-a-test__ab",
      disabledToolTip: /*#__PURE__*/_jsx(RunATestDisabledTooltip, {
        isAnyTestRunning: isAnyTestRunning,
        isPersonalized: isPersonalized,
        personalizationStrategyId: personalizationStrategyId !== null && personalizationStrategyId !== void 0 ? personalizationStrategyId : undefined
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "consolidatedRunTestEntryPoints.ab.description"
      }),
      isOptionDisabled: isOptionDisabled,
      onClick: () => {
        openRunTestModal(TEST_MODAL_TYPES.AB_TEST);
      },
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "mab.buttons.ab.header"
      })
    });
  }
  renderMAbTestOption() {
    const {
      mabCreatableMap,
      portalScopesRequest,
      openRunTestModal,
      isAnyTestRunning,
      isPersonalized,
      personalizationStrategyId
    } = this.props;
    const portalLacksMABAccess = (mabCreatableMap === null || mabCreatableMap === void 0 ? void 0 : mabCreatableMap.get('disabled')) && (mabCreatableMap === null || mabCreatableMap === void 0 ? void 0 : mabCreatableMap.get('reason')) === NO_TEST_ACCESS && requestSucceeded(portalScopesRequest);
    const isMabDisabledDueToSmartContent = !!(mabCreatableMap !== null && mabCreatableMap !== void 0 && mabCreatableMap.get('disabled') && (mabCreatableMap === null || mabCreatableMap === void 0 ? void 0 : mabCreatableMap.get('reason')) === SMART_CONTENT);
    if (portalLacksMABAccess) {
      return null;
    }
    const isOptionDisabled = isAnyTestRunning || isPersonalized || isMabDisabledDueToSmartContent;
    return /*#__PURE__*/_jsx(RunATestOption, {
      dataTestId: "run-a-test__mab",
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "consolidatedRunTestEntryPoints.mab.description"
      }),
      isOptionDisabled: isOptionDisabled,
      disabledToolTip: /*#__PURE__*/_jsx(RunATestDisabledTooltip, {
        isAnyTestRunning: isAnyTestRunning,
        isPersonalized: isPersonalized,
        isDisabledDueToSmartContent: isMabDisabledDueToSmartContent,
        personalizationStrategyId: personalizationStrategyId !== null && personalizationStrategyId !== void 0 ? personalizationStrategyId : undefined
      }),
      onClick: () => {
        openRunTestModal(TEST_MODAL_TYPES.MAB_TEST);
      },
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "consolidatedRunTestEntryPoints.mab.title"
      })
    });
  }
  renderRunTestOptions() {
    const {
      isPersonalized,
      isStagedContent,
      personalizationStrategyId
    } = this.props;

    // Do not show PQL or create test button for staged content or if this page is already part of
    // a test (maybe when the user/account downgraded and no longer has the test scope)
    // Brought over from legacy code -- maybe we want to show a message here?
    if (isStagedContent) {
      return null;
    }
    return /*#__PURE__*/_jsxs(List, {
      children: [this.renderRunAbTestOption(), this.renderMAbTestOption(), isPersonalized && /*#__PURE__*/_jsx(Text, {
        as: "p",
        paddingInline: "400",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: {
            Link
          },
          message: "consolidatedRunTestEntryPoints.disabledDueToPersonalization_jsx",
          options: {
            external: true,
            href: getManagePersonalizationVariantsUrl(personalizationStrategyId)
          }
        })
      })]
    });
  }
  render() {
    const {
      portalScopesRequest
    } = this.props;
    if (requestStarted(portalScopesRequest) || requestUninitialized(portalScopesRequest)) {
      return null;
    }
    return this.renderRunTestOptions();
  }
}
export default connect(mapStateToProps)(PatagoniaRunATestWrapper);